/*
 * /ai-access — как подключить ИИ-агента (MCP-клиент) к платформе: адрес MCP-сервера портала, команды для
 * клиентов, что агент может делать. Агент входит как пользователь (страница согласия /oauth2/authorize/:id)
 * и действует с его правами (PLAN-mcp.md).
 */
import { Typography, makeStyles } from '@material-ui/core';
import { CodeSnippet, Content, Header, InfoCard, Page } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

const useStyles = makeStyles(theme => ({
  grid: { display: 'grid', gap: theme.spacing(3), gridTemplateColumns: 'repeat(auto-fit, minmax(22rem, 1fr))' },
  p: { marginBottom: theme.spacing(1.5) },
}));

/** Адрес MCP-сервера ViVA портала (mcpActions.servers.viva в app-config). */
export const mcpServerUrl = (backendBaseUrl: string) => `${backendBaseUrl.replace(/\/$/, '')}/api/mcp-actions/v1/viva`;

export const AiAccessPage = () => {
  const classes = useStyles();
  const url = mcpServerUrl(useApi(configApiRef).getString('backend.baseUrl'));
  return (
    <Page themeId="tool">
      <Header title="ИИ-агенты" subtitle="MCP-сервер платформы: агент работает с порталом от вашего имени" />
      <Content>
        <div className={classes.grid}>
          <InfoCard title="Адрес MCP-сервера">
            <Typography className={classes.p}>
              Протокол — Streamable HTTP, вход — OAuth через портал (тот же вход GitLab). При первом подключении
              откроется страница «Вход ИИ-агента»: проверьте клиента и нажмите «Разрешить».
            </Typography>
            <CodeSnippet language="text" text={url} showCopyCodeButton />
          </InfoCard>
          <InfoCard title="Claude Code">
            <CodeSnippet language="bash" text={`claude mcp add --transport http viva ${url}`} showCopyCodeButton />
            <Typography className={classes.p} style={{ marginTop: 12 }}>
              Затем в Claude Code — <code>/mcp</code> → viva → Authenticate.
            </Typography>
          </InfoCard>
          <InfoCard title="VS Code, Cursor и другие клиенты">
            <CodeSnippet
              language="json"
              text={JSON.stringify({ mcpServers: { viva: { type: 'http', url } } }, null, 2)}
              showCopyCodeButton
            />
          </InfoCard>
          <InfoCard title="Что агент может сейчас">
            <Typography className={classes.p}>
              Только чтение: каталог ресурсов (кластеры, базы, брокеры, сервисы, модели, пулы узлов, команды), шаблоны
              и их проверочный запуск (dry-run), свои задачи шаблонов и их журналы.
            </Typography>
            <Typography className={classes.p}>
              Создание и изменение ресурсов через шаблоны — следующим этапом, с подтверждением человеком. Пароли и
              секреты агент не получает никогда.
            </Typography>
            <Typography className={classes.p}>
              Агент видит ровно то, что видите вы: права — ваши роли в Keycloak. Подключать агентов можно с политикой
              portal.mcp (есть у ролей команд и администраторов платформы).
            </Typography>
          </InfoCard>
        </div>
      </Content>
    </Page>
  );
};
